<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioSegmento" name="nomFormularioSegmento">
    <div class="grid form-group">
      <div class="col-8 md:col-8 lg:col-8">
        <div class="div-form">
          <label>* {{ 'POLITICAS.LBL_SEGMENTO' | translate }}</label>
          <p-multiSelect id="idSegmentos" name="nomSegmentos" [options]="lisSegmentos" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idSegmentos"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idSegmentos.invalid">
            {{ 'POLITICAS.LBL_SEGMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-4 md:col-4 lg:col-4">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="guardando"
               [value]="lisPoliticasSegmentos" selectionMode="single" dataKey="idPoliticaCreditoSegmento"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreSegmento}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="segmentos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
